export const SHELF_IDS = ["family", "drama", "kids", "action", "comedy", "scifi", "romance"];
export const SHELF_TITLES = {
    family: "Family",
    drama: "Drama",
    kids: "Kids",
    action: "Action & Adventure",
    comedy: "Comedy",
    scifi: "Sci-Fi",
    romance: "Romance",
};
/** How many discover pages a shelf may ask for; Home rotates through them daily. */
export const SHELF_MAX_PAGE = 10;
// Talk (10767), news (10763) and reality (10764) carry Comedy/Drama tags on
// TMDB: The Tonight Show topped TV Comedy. Kids' cartoons (10762) topped Action
// and Sci-Fi. They are left to their own rows.
const TV_NOT_SERIES = "10767,10763,10764";
const SHELF_QUERIES = {
    movie: {
        family: { with_genres: "10751", without_genres: "16", certification_country: "US", "certification.lte": "PG-13" },
        drama: { with_genres: "18" },
        kids: { with_genres: "16", certification_country: "US", "certification.lte": "PG" },
        action: { with_genres: "28|12" },
        comedy: { with_genres: "35" },
        scifi: { with_genres: "878" },
        romance: { with_genres: "10749" },
    },
    tv: {
        family: { with_genres: "10751", without_genres: `10762,${TV_NOT_SERIES}` },
        drama: { with_genres: "18", without_genres: `10762,${TV_NOT_SERIES}` },
        kids: { with_genres: "10762" },
        action: { with_genres: "10759", without_genres: `10762,${TV_NOT_SERIES}` },
        comedy: { with_genres: "35", without_genres: `10762,${TV_NOT_SERIES}` },
        scifi: { with_genres: "10765", without_genres: `10762,${TV_NOT_SERIES}` },
        romance: { with_keywords: "9840", without_genres: `10762,${TV_NOT_SERIES}` },
    },
};
export function isShelfId(value) {
    return typeof value === "string" && SHELF_IDS.includes(value);
}
/** The discover parameters for one page of a shelf. */
export function shelfDiscoverParams(media, shelf, page) {
    return {
        ...SHELF_QUERIES[media][shelf],
        with_origin_country: "US",
        with_original_language: "en",
        include_adult: "false",
        sort_by: "popularity.desc",
        // Enough votes that the row is titles people know, not obscure uploads.
        "vote_count.gte": media === "movie" ? "150" : "40",
        page: String(page),
    };
}
//# sourceMappingURL=shelves.js.map